export const LOGISTICS_ROUTE_NAMES = {
  ASSIGN_ORDERS: 'assign-orders',
  LOGISTICS: 'logistics',
  LOGISTICS_DELIVERIES: 'logistics-deliveries',
  LOGISTICS_LEARN_MORE: 'logistics-learn-more',
  LOGISTICS_SHIPMENTS: 'logistics-shipments',
  TRACK_ORDERS: 'track-orders',
  PROOF_OF_DELIVERY: 'proof-of-delivery',
};
